﻿import $ from "jquery";
import "bootstrap";
import { GuiDetailGeneric } from "../../GuiDetailGeneric";

export class GuiDetailAbfall extends GuiDetailGeneric {
    constructor() {
        super("Abfall");

        $("#VmDetail_AVV").on("change", () => this.changeAvv());
    }

    private changeAvv() {
        this.log("changeAvv");

        const gewSiedlungsabfalle = $("#VmDetail_AVV option:selected").data("data1");

        $("#VmDetail_GewerblicherSiedlungsabfall").prop("checked", gewSiedlungsabfalle === "True");
    }
}
